var pageHeader = {
    title: "Features",
    path: "/features"
};
export var solutionHighlights = {
    pageHeader: pageHeader,
};
export default solutionHighlights;
